import {InspectorControls, useBlockProps} from "@wordpress/block-editor";
import {registerBlockType} from '@wordpress/blocks';
import {
    Disabled,
    PanelBody,
    TextControl
} from '@wordpress/components';

import ServerSideRender from '@wordpress/server-side-render';
import {__} from "@wordpress/i18n";


registerBlockType(
    'hostim-block/newsletter-widget', {
        title: 'Hostim Newsletter',
        'icon': 'email-alt',
        'category': 'common',
        'keywords': ['newsletter', 'qutety', 'content box'],
        attributes: {
            title: {
                type: 'string',
            },
            content: {
                type: 'string',
            },
            btn_text: {
                type: 'string',
            }
        },

        edit: ({attributes, setAttributes}) => {
            const {
                content,
                btn_text
            } = attributes;
            return (
                <>
                    <div {...useBlockProps()}>
                        <InspectorControls>
                            <PanelBody title={__('Newsletter Widget Content', 'hostim-core')}>
                                <TextControl
                                    label={__('Description', 'hostim-core')}
                                    value={content}
                                    onChange={(content) =>
                                        setAttributes({content})
                                    }
                                />
                                <TextControl
                                    label={__('Button Text', 'hostim-core')}
                                    value={btn_text}
                                    onChange={(btn_text) =>
                                        setAttributes({btn_text})
                                    }
                                />
                            </PanelBody>
                        </InspectorControls>
                        <Disabled>
                            <ServerSideRender
                                block="hostim-block/newsletter-widget"
                                attributes={attributes}
                            />
                        </Disabled>
                    </div>
                </>
            )
        },
    }
);